// @ts-nocheck
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/require-default-props */
import React, { useCallback, useEffect } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step, { stepClasses } from '@mui/material/Step';
import StepLabel, { stepLabelClasses } from '@mui/material/StepLabel';
import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector';
import { Typography, Box } from '@mui/material';
import useEmblaCarousel from 'embla-carousel-react';
// @ts-ignore
import { ReactComponent as DatasetIcon } from '../../../assets/NimbusLoginPage/DataIngestion.svg';
import { ReactComponent as ModelUpload } from '../../../assets/NimbusLoginPage/ModelUpload.svg';
import { ReactComponent as AutomatedDocumentation } from '../../../assets/NimbusLoginPage/AutomatedDocumentation.svg';
import { ReactComponent as DataManagement } from '../../../assets/NimbusLoginPage/DataManagement.svg';
import { ReactComponent as SamplingSegmentation } from '../../../assets/NimbusLoginPage/Sampling&Segmentation.svg';
import { ReactComponent as Pipeline } from '../../../assets/NimbusLoginPage/Pipeline.svg';
import { ReactComponent as MetricSelection } from '../../../assets/NimbusLoginPage/MetricSelection.svg';
import { ReactComponent as ModelInterpretation } from '../../../assets/NimbusLoginPage/ModelInterpretation.svg';
import { ReactComponent as ModelEstimation } from '../../../assets/NimbusLoginPage/ModelEstimation.svg';
import { ReactComponent as ModelDevelopmentIcon } from '../../../assets/NimbusLoginPage/ModelDevelopment.svg';
import { ReactComponent as ModelValidationIcon } from '../../../assets/NimbusLoginPage/ModelValidation.svg';
import { ReactComponent as ModelMonitoringIcon } from '../../../assets/NimbusLoginPage/ModelMonitoring.svg';
import { ReactComponent as PreModelingSteps } from '../../../assets/NimbusLoginPage/PreModelingSteps.svg';
import { ReactComponent as ModelPerformanceAndTesting } from '../../../assets/NimbusLoginPage/ModelPerformanceAndTesting.svg';
import { ReactComponent as DefiningThresholdForMonitoringMetrics } from '../../../assets/NimbusLoginPage/DefiningThresholdForMonitoringMetrics.svg';
import { ReactComponent as ModelTestingAndComparison } from '../../../assets/NimbusLoginPage/ModelTestingAndComparison.svg';
import { ReactComponent as MonitoringPipelineAndScheduler } from '../../../assets/NimbusLoginPage/MonitoringPipelineAndScheduler.svg';
import { ReactComponent as SensitivityAndSchenarioAnalysis } from '../../../assets/NimbusLoginPage/SensitivityAndSchenarioAnalysis.svg';
import { ReactComponent as ModelReplicationAndBenchmarking } from '../../../assets/NimbusLoginPage/ModelReplicationAndBenchmarking.svg';
import { ReactComponent as CounterPartyCreditRisk } from '../../../assets/NimbusLoginPage/CounterPartyCreditRisk.svg';
import { ReactComponent as StressTesting } from '../../../assets/NimbusLoginPage/StressTesting.svg';
import { ReactComponent as VarModelling } from '../../../assets/NimbusLoginPage/VarModelling.svg';
import { ReactComponent as LiquidityRisk } from '../../../assets/NimbusLoginPage/LiquidityRisk.svg';
import { ReactComponent as IRRBBReporting } from '../../../assets/NimbusLoginPage/IRRBBReporting.svg';
import { ReactComponent as CryptoPNLModelling } from '../../../assets/NimbusLoginPage/CryptoPNLModelling.svg';
import { ReactComponent as PPNRModelling } from '../../../assets/NimbusLoginPage/PPNRModelling.svg';
import { ReactComponent as CECICalculator } from '../../../assets/NimbusLoginPage/CECICalculator.svg';

const STEP_ICON_TRANSITION = '.5s ease-in';
const DATA_INGESTION = 'Data Ingestion';
const MODEL_INTERPRETATION = 'Model Interpretation';
const AUTOMATED_DOCUMENTATION = 'Automated Documentation';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  marginLeft: '20px',
  width: 5,
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      background: theme.palette?.other?.green1,
      transition: STEP_ICON_TRANSITION,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      background: theme.palette?.other?.green1,
      transition: STEP_ICON_TRANSITION,
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 30,
    border: 0,
    backgroundColor: theme.palette?.other?.white,
    borderRadius: 1,
  },
}));

const EmblaCarousel = styled(Box)({
  overflow: 'hidden',
  width: '650px',
  height: '100%',
});

const EmblaContainer = styled(Box)({
  display: 'flex',
});

const EmblaSlide = styled(Box)({
  flex: '0 0 100%',
  minWidth: 0,
});

const EmblaIndicators = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '30px',
  gap: '6px',
});

const EmblaIndicator = styled('button')(({ theme, active }) => ({
  width: '11px',
  height: '11px',
  minWidth: '11px',
  minHeight: '11px',
  borderRadius: '50%',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  margin: 0,
  backgroundColor: active
    ? theme.palette.other.carouselButton
    : theme.palette.error.contrastText,
  transition: 'background-color 1s ease',
}));

const sliderAndSteps = [
  {
    name: 'Model Development',
    steps: [
      { name: 'Model Development', icon: ModelDevelopmentIcon },
      { name: DATA_INGESTION, icon: DatasetIcon },
      { name: 'Data Management', icon: DataManagement },
      { name: 'Pre-Modelling Steps', icon: PreModelingSteps },
      { name: 'Sampling & Segmentation', icon: SamplingSegmentation },
      { name: 'Model Estimation', icon: ModelEstimation },
      {
        name: 'Model Performance Testing/Outcome Analysis',
        icon: ModelPerformanceAndTesting,
      },
      { name: MODEL_INTERPRETATION, icon: ModelInterpretation },
      { name: AUTOMATED_DOCUMENTATION, icon: AutomatedDocumentation },
    ],
  },
  {
    name: 'Model Monitoring',
    steps: [
      { name: 'Model Monitoring', icon: ModelMonitoringIcon },
      { name: DATA_INGESTION, icon: DatasetIcon },
      { name: 'Model Upload (R/Python/SAS)', icon: ModelUpload },
      { name: 'Monitoring Metrics Selection', icon: MetricSelection },
      {
        name: 'Define Threshold For Monitoring Metrics',
        icon: DefiningThresholdForMonitoringMetrics,
      },
      { name: 'Model Testing/Comparison', icon: ModelTestingAndComparison },
      { name: MODEL_INTERPRETATION, icon: ModelInterpretation },
      { name: AUTOMATED_DOCUMENTATION, icon: AutomatedDocumentation },
      {
        name: 'Monitoring Pipeline/Scheduler',
        icon: MonitoringPipelineAndScheduler,
      },
    ],
  },
  {
    name: 'Model Validation',
    steps: [
      { name: 'Model Validation', icon: ModelValidationIcon },
      { name: DATA_INGESTION, icon: DatasetIcon },
      { name: 'Data Validation/Data Quality Check/EDA', icon: DataManagement },
      { name: 'Model Upload (R/Python/SAS)', icon: ModelUpload },
      {
        name: 'Model Replication/Benchmarking',
        icon: ModelReplicationAndBenchmarking,
      },
      {
        name: 'Model Performance Testing/Outcome Analysis',
        icon: ModelPerformanceAndTesting,
      },
      {
        name: 'Sensitivity & Scenario Analysis',
        icon: SensitivityAndSchenarioAnalysis,
      },
      { name: MODEL_INTERPRETATION, icon: ModelInterpretation },
      { name: AUTOMATED_DOCUMENTATION, icon: AutomatedDocumentation },
    ],
  },
  {
    name: 'Pipeline Manager',
    steps: [
      { name: 'Pipeline Manager', icon: Pipeline },
      { name: 'Counter Party Credit Risk', icon: CounterPartyCreditRisk },
      { name: 'Stress Testing', icon: StressTesting },
      { name: 'VaR Modelling', icon: VarModelling },
      {
        name: 'Liquidity Risk',
        icon: LiquidityRisk,
      },
      {
        name: 'IRRBB Reporting',
        icon: IRRBBReporting,
      },
      {
        name: 'Crypto PNL Modelling',
        icon: CryptoPNLModelling,
      },
      { name: 'CECL Calculator', icon: CECICalculator },
      { name: 'PPNR Modelling', icon: PPNRModelling },
    ],
  },
];

export default function LoginPageAnimation() {
  const theme = useTheme();
  const [stepCounter, setStepCounter] = React.useState(0);
  const [activeSlide, setActiveSlide] = React.useState(0);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    skipSnaps: false,
    duration: 20,
  });

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setActiveSlide(emblaApi.selectedScrollSnap());
    setStepCounter(0);
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on('select', onSelect);
  }, [emblaApi, onSelect]);

  const scrollTo = useCallback(
    (index) => emblaApi && emblaApi.scrollTo(index),
    [emblaApi]
  );
  React.useEffect(() => {
    const timer = setTimeout(() => {
      const currentSlideSteps = sliderAndSteps[activeSlide]?.steps?.length || 0;

      if (stepCounter === currentSlideSteps) {
        const nextSlide = (activeSlide + 1) % sliderAndSteps.length;
        scrollTo(nextSlide);
      } else {
        setStepCounter(stepCounter + 1);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [stepCounter, activeSlide, scrollTo]);

  return (
    <Stack width="100%" spacing={4} aria-label="Carousel">
      <EmblaCarousel ref={emblaRef}>
        <EmblaContainer>
          {sliderAndSteps.map((slide, slideIndex) => (
            <EmblaSlide key={slide.name}>
              <Stepper
                orientation="vertical"
                activeStep={activeSlide === slideIndex ? stepCounter : -1}
                connector={<ColorlibConnector />}
                component="ul"
                sx={{
                  listStyleType: 'none',
                }}
                aria-label={`${slide?.name} slide`}
              >
                {slide.steps.map((step, stepIndex) => (
                  <Step key={step?.name} component="li">
                    <StepLabel
                      StepIconComponent={step.icon}
                      sx={{
                        padding: 0,
                        [`.${stepLabelClasses.iconContainer}`]: {
                          backgroundColor: theme.palette?.other?.white,
                          zIndex: 1,
                          color: theme.palette.primary.main,
                          width: stepIndex === 0 ? 50 : 35,
                          height: stepIndex === 0 ? 50 : 35,
                          display: 'flex',
                          borderRadius: '50%',
                          justifyContent: 'center',
                          alignItems: 'center',
                          transition: STEP_ICON_TRANSITION,
                          padding: 0,
                          marginLeft: stepIndex === 0 ? 0 : '5px',
                        },
                        [`.${stepClasses.completed}`]: {
                          [`&.${stepLabelClasses.iconContainer}`]: {
                            background: theme.palette?.other?.green1,
                            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
                          },
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          ml: 2,
                          fontSize: stepIndex === 0 ? '22px' : '18px',
                          fontWeight: 600,
                          fontStyle: 'normal',
                          color: theme.palette?.other?.white,
                        }}
                      >
                        {step?.name}
                      </Typography>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </EmblaSlide>
          ))}
        </EmblaContainer>
      </EmblaCarousel>

      <EmblaIndicators>
        {sliderAndSteps.map((slide, index) => (
          <EmblaIndicator
            key={slide.name}
            active={index === activeSlide}
            onClick={() => scrollTo(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </EmblaIndicators>
    </Stack>
  );
}
